import AuthorizedAxiosInstance from '../../../libs/axios/AuthorizedAxiosInstance'

export const getUnsubscribeInfo = () =>
	AuthorizedAxiosInstance.get(`/api/sendgrid/unsubscribe-info`)

export const postUnsubscribePreferences = groups =>
	AuthorizedAxiosInstance.post(`/api/sendgrid/unsubscribe-preferences`, {
		groups
	})
